import "./ReachUs.module.css";
import Header from "@/reusable_sections/Header";
import ReachOurCareTeam from "./sections/ReachOurCareTeam";
import TheFinePrint from "./sections/TheFinePrint";
import Footer from "@/reusable_sections/Footer";
export default function ReachUsPage() {
  return <div>
      <Header />
      <ReachOurCareTeam />
      <TheFinePrint />
      <Footer />
    </div>;
}